import { render, staticRenderFns } from "./formdialogsp.vue?vue&type=template&id=1e64992c&scoped=true"
import script from "./formdialogsp.vue?vue&type=script&lang=js"
export * from "./formdialogsp.vue?vue&type=script&lang=js"
import style0 from "./formdialogsp.vue?vue&type=style&index=0&id=1e64992c&prod&lang=css"
import style1 from "./formdialogsp.vue?vue&type=style&index=1&id=1e64992c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e64992c",
  null
  
)

export default component.exports